
import * as actionTypes from './actionTypes';

export const getSecondSsid = () => {
  return {
    type: actionTypes.GET_SECOND_SSID
  };
};

export const getSecondSsidSuccess = (payload) => ({
  type: actionTypes.GET_SECOND_SSID_SUCCESS,
  payload
});

export const getSecondSsidFail = () => ({
  type: actionTypes.GET_SECOND_SSID_FAIL
});

export const getSecondSsidLoading = () => ({
  type: actionTypes.GET_SECOND_SSID_LOADING
});

export const setSecondSsidInfoFailed = () => ({
  type: actionTypes.SET_SECOND_SSID_INFO_FAIL
});

export const setSecondSsidInfoSuccess = () => ({
type: actionTypes.SET_SECOND_SSID_INFO_SUCCESS
});

export const setSecondSsidInfoFailedMessage = (info) => ({
  type: actionTypes.SET_SECOND_SSID_INFO_FAIL_MESSAGE,
  info
}); 

export const resetSecondSsidErrorSuccess = () => {
  return {
    type: actionTypes.RESET_SECOND_SSID_ERROR_SUCCESS
  }
}

export const setSecondSsidInfoDetails = (info) => {
  return {
    type: actionTypes.SET_SECOND_SSID_INFO, 
    info
  }
}

export const addSecondSsidInfoDetails = (info) => {
  return {
    type: actionTypes.ADD_SECOND_SSID_INFO,
    info
  }
}

export const deleteSecondSsidInfoDetails = (info) => {
  return {
    type: actionTypes.DELETE_SECOND_SSID_INFO,
    info
  }
}

export const deleteSecondSsidSuccess = (info) => {
  return {
    type: actionTypes.DELETE_SECOND_SSID_INFO_SUCCESS,
    info
  }
}

export const deleteSecondSsidFailed = (info) => {
  return {
    type: actionTypes.DELETE_SECOND_SSID_INFO_FAILED,
    info
  }
}



